import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import { WorkoutInfo } from '../containers/Workouts';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

const stylesWorkout = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitleWorkout = withStyles(stylesWorkout)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContentWorkout = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default class WorkoutPreviewButton extends Component {
  state = {
    open: false,
    planNotes: []
  };

  render() {
    const { workout, isViewProgramNotes, clientEmail, getProgramWorkoutNotes } = this.props;
    const { open, planNotes } = this.state;
    if (!workout) return null;
    return (
      <div>
        <Dialog  onClose={() => this.setState({ open: false })} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitleWorkout id="customized-dialog-title" onClose={() => this.setState({ open: false })}>
          Preview
        </DialogTitleWorkout>
          <DialogContentWorkout dividers>
            <Typography gutterBottom component="span">
              <div className="modalBody modal-content" style={{ width: 320 }}>
                { isViewProgramNotes ? 
                  <WorkoutInfo isViewNotes={true} planNotes={planNotes} workoutId={workout._id} /> : 
                  <WorkoutInfo   workoutId={workout._id} />
                }
              </div>
            </Typography>
          </DialogContentWorkout>
      </Dialog>
        <span
          className="link"
          onClick={ () => {
            if(!isViewProgramNotes) {
              this.setState({ open: true })
            } else {
              getProgramWorkoutNotes({
                email: clientEmail,
                workoutId: workout._id
              }).then((data) => {
                this.setState({
                  open: true,
                  planNotes: data.planNotes,
                })
              });
            }
          }}
          style={{ float: 'right' }}>
          <FontAwesomeIcon icon="eye" title={"Preview"}
            style={{ marginRight: 5, color: COLORS.orange }} />
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WorkoutPreviewButton.js